import { TvQuoteSubscriptionItem } from './TvQuoteSubscriptionItem';
export class TvQuoteSubscriptionsContainer {
    constructor() {
        this.subscriptionsMap = new Map();
    }
    subscribeQuotes(symbols, fastSymbols, onRealtimeCallback, listenerGUID) {
        if (!this.subscriptionsMap.has(listenerGUID)) {
            const newSubscriptionItem = new TvQuoteSubscriptionItem();
            this.subscriptionsMap.set(listenerGUID, newSubscriptionItem);
        }
        const subscriptionItem = this.subscriptionsMap.get(listenerGUID);
        subscriptionItem.subscribe(symbols, fastSymbols, onRealtimeCallback);
    }
    unsubscribeQuotes(listenerGUID) {
        if (!this.subscriptionsMap.has(listenerGUID)) {
            return;
        }
        const subscriptionItem = this.subscriptionsMap.get(listenerGUID);
        subscriptionItem.unsubscribe();
        this.subscriptionsMap.delete(listenerGUID);
    }
    changeCurrentAccount() {
        this.subscriptionsMap.forEach((subscriptionItem) => {
            subscriptionItem.throttledSendRealtimeData();
        });
    }
}
